import { createContext, useContext, useState, useCallback } from "react";

const FeedbackContext = createContext(undefined);

export function FeedbackProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [feedbackType, setFeedbackType] = useState("feedback"); // "feedback" or "bug"
  const [feedbackContext, setFeedbackContext] = useState({});

  const openFeedbackModal = useCallback((type = "feedback", context = {}) => {
    setFeedbackType(type);
    setFeedbackContext(context || {});
    setIsOpen(true);
  }, []);

  const closeFeedbackModal = useCallback(() => {
    setIsOpen(false);
    setFeedbackContext({});
  }, []);

  return (
    <FeedbackContext.Provider
      value={{
        isOpen,
        feedbackType,
        feedbackContext,
        openFeedbackModal,
        closeFeedbackModal,
      }}
    >
      {children}
    </FeedbackContext.Provider>
  );
}

export const useFeedback = () => {
  const context = useContext(FeedbackContext);
  if (!context) {
    throw new Error("useFeedback must be used within FeedbackProvider");
  }
  return context;
};
